import { Nullable } from 'global';
import { Charge } from 'modules/equipment/types';

import { Quote } from '../types';
import { calculateTotal, newChargeRow } from '../../equipment';
import { CreateOrUpdateQuoteVariables } from '../api/types';

function mapFee({ type, label, price }: Charge, equipmentId: string) {
  return {
    type,
    price,
    equipmentId,
    amountType: 'flat',
    description: label,
    amount: calculateTotal(price),
  };
}

export function collectEquipmentQuoteVariables(
  equipment: { equipmentId: string } & Record<string, any>,
  quote: Nullable<Quote>,
  charges: Charge[]
): Omit<CreateOrUpdateQuoteVariables['input'], 'vendorOpportunityId'> {
  const equipmentEntry: CreateOrUpdateQuoteVariables['input']['equipment'][number] = {
    attributes: [],
    externalId: '',
    cost: equipment.retailPrice,
    equipmentId: equipment.equipmentId,
    stockNumber: equipment.stockId ?? '',
    vin: equipment.serialNumberVin ?? '',
    price: equipment.price ?? { ...newChargeRow, retailPrice: equipment.retailPrice ?? 0 },
  };

  if (!quote) {
    return {
      fees: charges.map(charge => mapFee(charge, equipment.equipmentId)),
      equipment: [equipmentEntry],
      term: null,
      downPayment: null,
      interestRate: null,
      paymentAmount: null,
      contractStartDate: null,
      firstPaymentDueDate: null,
      rebates: [],
      attributes: [],
      cashBackAmounts: [],
      equipmentTradeIns: [],
      aftermarketProducts: [],
    };
  }

  const otherFees = quote.fees.filter(fee => fee.equipmentId !== equipment.equipmentId);
  const newFees = charges.map(charge => mapFee(charge, equipment.equipmentId));
  const mergedFees = [...otherFees, ...newFees];

  return {
    ...quote,
    fees: mergedFees,
    equipment: quote.equipment.map(quoteEquipment =>
      equipment.equipmentId === quoteEquipment.equipmentId ? equipmentEntry : quoteEquipment
    ),
  };
}
